import {
  asyncRequest,
  getComponentConfig,
  registerComponent,
  replaceDOM,
} from "helpers";

registerComponent(
  "product-recommendations",
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.config = getComponentConfig(this);
      this.loadRecommendations();
    }

    loadRecommendations = async () => {
      const html = await asyncRequest(this.config.endpoint);

      replaceDOM(
        html,
        `[data-product-recommendations="${this.config.sectionID}"]`
      );
    };
  }
);